import React, { useState } from "react";
import { AiOutlineFileSearch } from "react-icons/ai";
import "./tab_style.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
    PaginationProvider,
    PaginationTotalStandalone,
    PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import { Button, Col, Container, Row } from "react-bootstrap";
const Open_orders = ({ openOrders }) => {
    const [selectedRows, setSelectedRows] = useState<any>([]);
console.log('openorder',openOrders)
    const columns = [
        { text: "Dates", dataField: "createdAt", 
        formatter: (cellContent, row) => {
            // Assuming cellContent is a valid JavaScript date format
            const date = new Date(cellContent);
            return date.toLocaleString();
        }
    },
        { text: "Pair", dataField: "pair_name",  },
        { text: "Type", dataField: "type",  },
        { text: "Direction", dataField: "method", 
        formatter: (cellContent, row) => {
            return <span style={{ color: cellContent=='sell'?'#F65D62':'#0CAA6D' }}>{cellContent}</span>;
        },
    },
        { text: "Price", dataField: "target_price",  },
        { text: "Amount", dataField: "amount",  },
        { text: "Filled", dataField: "fill",  },
        {
            text: '', 
            dataField: 'cancel',
            headerFormatter: (column, colIndex,) => {
                return (
                    <div>   
                        <Button variant="border-none" size="sm" style={{ background: '#f5f1f1', fontSize: '10px', color: '#000', padding: '1px 6px',whiteSpace: 'nowrap' }} onClick={handleCancelAllOrder}>Cancel All</Button>
                    </div>
                );
            },
            formatter: (cell, row) => {
                return (
                    <div>
                        <Button variant="secondary border-none" size="sm" style={{ background: '#f5f1f1', fontSize: '12px', color: '#000', padding: '1px 6px',whiteSpace: 'nowrap' }} onClick={() => handleCancelOrder(row)}>Cancel</Button>
                        {/* <button onClick={() => handleCancelRow(row)}>Cancel</button> */}
                    </div>
                );
            },

        }




    ];
    function handleCancelAllOrder() {
        //call api to canel all order
    }
    function handleCancelOrder(row) {
        // Logic to cancel a specific row
        console.log("Cancelled row:", row);
    }
    const options = {
        custom: true,
        totalSize: openOrders.length
    };
    // const selectRow = {
    //     mode: 'checkbox',
    //     clickToSelect: true,
    //     selectColumnPosition: 'right',
    //     onSelect: (row, isSelect, rowIndex, e) => {
    //         if (isSelect) {
    //             setSelectedRows(prevRows => [...prevRows, row]);
    //         } else {
    //             setSelectedRows(prevRows => prevRows.filter((r) => r._id !== row._id))
    //         }
    //     },
    //     onSelectAll: (isSelect, rows, e) => {
    //         console.log('rows data', rows)
    //         if (isSelect) {
    //             setSelectedRows(rows);
    //         } else {
    //             setSelectedRows([]);
    //         }
    //     }
    // };
    // console.log('selectedRows', selectedRows)
    return (
        <>
            <Container fluid className="p-0">
                <Row>
                    <Col>
                        {openOrders.length > 0 &&
                            <PaginationProvider
                                pagination={paginationFactory(options)}
                            >
                                {
                                    ({
                                        paginationProps,
                                        paginationTableProps
                                    }) => (
                                        <div className="boot_table">
                                            <BootstrapTable
                                                keyField="_id"
                                                bordered={false}
                                                data={openOrders}
                                                columns={columns}
                                                // selectRow={selectRow}
                                                {...paginationTableProps}
                                                className= 'nexTable'
                                            />

                                            {

                                                openOrders.length > 10 && (
                                                    <>
                                                        <PaginationTotalStandalone {...paginationProps} />

                                                        <PaginationListStandalone {...paginationProps} />
                                                    </>
                                                )
                                            }

                                        </div>
                                    )
                                }
                            </PaginationProvider>

                        }
                        {
                            openOrders.length < 1 &&
                            <div className='d-flex flex-column align-items-center justify-content-center mt-5' style={{color: 'var(--text-clr)'}}>
                                <div className='display-6'>
                                    <i> <AiOutlineFileSearch /> </i>
                                </div>
                                <div>
                                    <span>No records found</span>
                                </div>
                            </div>

                        }
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Open_orders
